import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { DialogService } from "@teammood/shared/ui/dialog";
import { TranslateService } from "@ngx-translate/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "@teammood/shared/ui/dialog";
import { PollInTeam, PollListItem, PollOccurrence } from "./user-polls.type";
import { SendPollReminderDialogComponent } from "./send-poll-reminder-dialog/send-poll-reminder-dialog.component";
import { MakePollRecurrentDialogComponent } from "./make-poll-recurrent-dialog/make-poll-recurrent-dialog.component.ts";
import { RecurrenceType } from "../create-poll/create-poll.type";
import { PollResultsDialogComponent } from "./poll-results-dialog/poll-results-dialog.component";
import { getDaysInMonth, format, getWeek, add, sub } from "date-fns";
import { TrendPollResultsDialogComponent } from "./trend-poll-results-dialog/trend-poll-results-dialog.component";
import { DatePipe } from '@angular/common';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class UserPollsService {
    locale: string;
    datePipe: DatePipe;
    constructor(
      @Inject(LOCALE_ID) locale: string,
        private _dialogService: DialogService,
        private _translateService: TranslateService
    ){
        this.locale = locale;
        this.datePipe = new DatePipe(this.locale);
    }

    async openDeletionConfirmationDialog(): Promise<MatDialogRef<ConfirmDialogComponent, boolean>> {
        return await this._dialogService.openConfirmDialog({
          title: this._translateService.instant('polls_settings.delete_question'),
          message: this._translateService.instant('polls_settings.delete_question.desc'),
          confirmBtnLabel: 'delete',
          confirmBtnType: 'danger'
        });
    }

    async openPollResultsDialog(pollOccurrenceId: string): Promise<MatDialogRef<PollResultsDialogComponent>> {
        return this._dialogService.open(PollResultsDialogComponent, {
          width: '100%',
          maxWidth: '1200px',
          enterAnimationDuration: 300,
          exitAnimationDuration: 0,
          data: {
              pollOccurrenceId: pollOccurrenceId,
          }
        })
    }

    async openTrendPollResultsDialog(pollId: string, teams: string[]): Promise<MatDialogRef<TrendPollResultsDialogComponent>> {
      return this._dialogService.open(TrendPollResultsDialogComponent, {
        width: '100%',
        maxWidth: '1200px',
        enterAnimationDuration: 300,
        exitAnimationDuration: 0,
        data: {
            pollAggregateId: pollId,
            teams: teams,
        }
      })
  }

    async openSendPollReminderDialog(poll: PollListItem): Promise<MatDialogRef<SendPollReminderDialogComponent>> {
    return this._dialogService.open(SendPollReminderDialogComponent, {
        width: '100%',
        maxWidth: '500px',
        enterAnimationDuration: 0,
        exitAnimationDuration: 0,
        data: {
          poll: poll,
        }
    })
    }

    async openMakeRecurrentDialog(poll: PollListItem, frequency: RecurrenceType): Promise<MatDialogRef<MakePollRecurrentDialogComponent>> {
      return this._dialogService.open(MakePollRecurrentDialogComponent, {
          width: '100%',
          maxWidth: '500px',
          enterAnimationDuration: 0,
          exitAnimationDuration: 0,
          data: {
            poll: poll,
            frequency: frequency
          }
      })
    }
    getFrequencyStartDay(startDate: Date, type: string){
      switch(type){
          case 'weekly':
              return format(startDate, 'iiii');
          case 'monthly':
              return getDaysInMonth(startDate);
      }
  }

    getOccurrenceDate(occurrence: PollOccurrence, type: string){
      switch(type){
           case 'once':
              return this.datePipe.transform(occurrence.startDate, 'longDate');
          case 'weekly':
              return this._translateService.instant('polls_settings.recurrence.week') + ' '+ getWeek(occurrence.startDate);
          case 'monthly':
              return format(occurrence.startDate, 'MMMM');
      }
  }
  getOccurrenceDateDetail(occurrence: PollOccurrence){
      if(occurrence.startDate && occurrence.endDate){
          const start = this.datePipe.transform(occurrence.startDate, 'longDate');
          const end = this.datePipe.transform(sub(occurrence.endDate, { days: 1 }), 'longDate'); // endDate goes to 23:59:59 is tranform to next day
          return this._translateService.instant('polls_settings.occurrence.desc') 
          + ' ' + start + ' '
          + this._translateService.instant('polls_settings.occurrence.to') 
          + ' ' + end;
      }
  }

  getLiveOccurrenceDateDetail(occurrence: PollOccurrence){
    if(occurrence.startDate && occurrence.endDate){
      const resultDate = add(occurrence.endDate, { hours: 1 }) // endDate goes to 23:59:59         
      const resultLongDate = this.datePipe.transform(resultDate, 'longDate');
      return this._translateService.instant('polls_settings.occurrence.live_tooltip', {day: resultLongDate});
    }
}

  getOccurrenceParticipation(teams: PollInTeam[]){
      let participation = 0;
      teams.forEach(tm => {
          participation += tm.participation;
      });
      return participation;
  }

    
      
}

